// extracted by mini-css-extract-plugin
export default {"specialOffer":"special-offer__specialOffer___2d2CN"};